<ion-content class="modal-container">
  <div class="modal-header">
    <h2>Descarga de Certificado de Ofertas SCOMP</h2>
    <ion-icon name="close-outline" role="button" (click)="cerrar()" (keypress)="keyPressClose($event)" tabindex="0"
      aria-label="Cerrar"></ion-icon>
    <div *ngIf="isResponsive">
      <app-descarga-certificado-stepper [customSteps]="pasos"></app-descarga-certificado-stepper>
    </div>
  </div>

  <div class="modal-body" [class.no-footer]="pasoActual === 2 || pasoActual === 3">
    <div class="stepper" *ngIf="!isResponsive">
      <app-descarga-certificado-stepper [customSteps]="pasos"></app-descarga-certificado-stepper>
    </div>

    <div class="content">
      <ng-container [ngSwitch]="pasoActual">

        <div *ngSwitchCase="1">
          <h3>Consideraciones</h3>
          <ul>
            <li>Solo podrás obtener tu certificado si cuentas con tus datos actualizados y Clave de Seguridad.</li>
            <li>
              Puedes revisar tu información registrada y actualizarla en <a class="link" (click)="goToPerfil()">Tus
                datos.</a>
            </li>
          </ul>

          <div class="details-datos-personales">
            <div class="detail-item ">
              <span>Teléfono:</span>
              <span>{{ (datosPersonales.telefono | formatPhoneNumber) || 'Aún no registras tu teléfono'}}</span>
            </div>
            <div class="detail-item ">
              <span>Correo:</span>
              <span>{{ datosPersonales.email }}</span>
            </div>
          </div>
        </div>

        <div *ngSwitchCase="2">
          <ng-template #microfrontContainer></ng-template>
        </div>

        <div *ngSwitchCase="3" class="details-descarga-certificado">
          <div *ngIf="!errorServiceDescargaCertificado">
            <h3>Descarga de certificado</h3>
            <ul>
              <li>Luego de conocer la información disponible en el Certificado de Ofertas SCOMP deberás elegir una
                modalidad, de lo contrario no podrás continuar con el trámite.</li>
              <li>Selecciona la modalidad mediante una <a href="/video-atencion">Video Atención</a>.</li>
            </ul>

            <div class="details-datos-personales">
              <div class="detail-item ">
                <span>Vigencia del documento:</span>
                <span>{{ getVigenciaCertificado }}</span>
              </div>
            </div>
          </div>

          <div *ngIf="errorServiceDescargaCertificado" class="errorServiceDescargaCertificado">
            <ion-icon name="alert-circle" class="icon-error"></ion-icon>
            <h3>Lo sentimos, ocurrió un error al descargar tu certificado</h3>
            <p>Por favor, reinténtalo o ingresa más tarde</p>

            <div class="details-datos-personales">
              <strong>Para más información</strong>
              <p>Llámanos al <a href="tel:+6006600900">600 6600 900</a> o agenda una <a href="/video-atencion">Video
                  Atención.</a></p>
            </div>
            <div class="buttons-error-service">
              <button (click)="reintentarErrorDescarga()" class="btn-continuar"
                (keydown.enter)="reintentarErrorDescarga()" [disabled]="loading">
                Reintentar <ion-icon name="refresh" *ngIf="!attempt"
                  style="font-size: 20px; margin-left: 5px;"></ion-icon>
                <ion-spinner name="crescent" slot="end" *ngIf="attempt" color="light"></ion-spinner></button>
              <button (click)="onGoToInicioTramite()" class="btn-continuar secondary-button"
                (keydown.enter)="onGoToInicioTramite()" [disabled]="loading">
                Ir a Inicio del trámite
              </button>
            </div>
          </div>
        </div>

        <div *ngSwitchCase="4" class="content-comprobante">
          <ion-icon name="checkmark-circle-sharp" class="icon-check"></ion-icon>
          <h3>Tu certificado fue descargado con éxito</h3>

          <p>Podrás encontrarlo en tu carpeta de Descargas.</p>

          <p><strong>¿Qué viene ahora?</strong><br>
            <strong>Comunícate con uno de nuestros ejecutivos a través de una <a class="link"
                (click)="goToVideAtencion()">video
                atención</a> o llamando al
              <a href="tel:+6006600900" class="link-phone">600 6600 900</a></strong> para seleccionar la modalidad o en
            caso de tener dudas
            con la información entregada. Esto debes hacerlo antes de la fecha de vencimiento del documento, de lo
            contrario tu trámite se cerrará.
          </p>

          <div class="details-datos-personales">
            <div class="detail-item ">
              <span>Documento:</span>
              <span>Certificado de Ofertas SCOMP</span>
            </div>
            <div class="detail-item ">
              <span>Fecha:</span>
              <span>{{ fechaDescargaCertificado | date: 'dd/MM/yyyy' }}</span>
            </div>
          </div>
        </div>

      </ng-container>
    </div>
  </div>

  <div class="modal-footer" *ngIf="pasoActual !== 2 && pasoActual !== 3">
    <ion-button (click)="avanzar()" class="btn-continuar" (keydown.enter)="avanzar()">
      {{ pasoActual < pasos.length ? 'Continuar' : 'Volver al inicio del Trámite' }} </ion-button>
  </div>

  <div class="modal-footer" *ngIf="pasoActual === 3 && !errorServiceDescargaCertificado">
    <ion-button (click)="descargarCertificado()" class="btn-continuar"
      (keydown.enter)="descargarCertificado()" [disabled]="loading">
      Descargar Certificado <ion-spinner name="crescent" slot="end" *ngIf="loading"
        color="light"></ion-spinner></ion-button>
  </div>

</ion-content>